import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance, { axiosCacheInstance } from '../../../../axiosSetup';
import { AxiosError } from 'axios';

import { updateAgentPartnerId } from '../../blRequestInstruction/components/instructionSlice/AgentNominationSlice';
import {
  updateBLPartyList,
  updateInstructionTypes,
} from '../../blDetails/slices/documentHistorySlice';
import { toast } from 'react-toastify';
import {
  updatePickupLocation,
  updateSelectedDateDV,
} from '../../blRequestInstruction/components/instructionSlice/DemurrageSlice';
import { updatePickupLocation as updateDoExtensionPickupLocation } from '../../blRequestInstruction/components/instructionSlice/DOExtensionSlice';
import { AESDecrypt } from '../../../../encrypt-util';
import { updateReturnSelectedDateDV } from '../../blRequestInstruction/components/instructionSlice/ReturnSlice';
import {
  updateReleaseTypeList,
  updateReturnTypeList,
} from '../../blRequestInstruction/components/instructionSlice/InvoiceChangeSlice';
import { updateReturnTypeListForExport } from '../../blRequestInstruction/components/instructionSlice/ExportInvoiceChangeSlice';
import { updateDestuffingTpList } from '../../blRequestInstruction/components/instructionSlice/PickupSlice';
import { updateStandingInstructionTypes } from '../../standingInstruction/slices/standingInstructionTable';
import { getDateFormat, getDateTimeFormat } from '../../../../helpers/dateFormat';
import moment from 'moment';
import { RootState } from '../../template/store';

// Enable while using mock data
// import axios from 'axios'

// export const getInvDashboardDefinition = createAsyncThunk(
//   'instruction/getInvDashboardDefinition',
//   async () => {
//     try {
//       const response = await axiosInstance.get(
//         '/api/user-management/v1/usergrid/masterGrids?linerId=1&country=US'
//       );

//       return (
//         response.data?.list?.find?.((f: any) => f?.gridName === 'INV_DASHBOARD')
//           ?.columnConfig || []
//       );
//     } catch (error) {
//       return [];
//     }
//   }
// );

export const getInstructionList = createAsyncThunk(
  'instruction/getInstruction',
  async (filterData: any) => {
    try {
      const params = new URLSearchParams();
      if (filterData.country) params.set('country', filterData.country);
      if (filterData.language) params.set('language', filterData.language);
      if (filterData.linerId) params.set('linerId', filterData.linerId);
      const response = await axiosInstance.get(
        `/api/edo-rest-v2/v2/bl/${filterData.blNum}/event?${params.toString()}`
      );
      const data = response.data.map((v: any) => ({
        blEventId: v?.blEventId || null,
        blId: v?.blId || null,
        document: v?.docType || null,
        documentNumber: v?.docNumber || null,
        docStatus: v?.docStatus || null,
        event: v?.event || null,
        eventLabel: v?.eventLabel || v?.event || null,
        time: v?.timestamp || null,
        ccy: v?.currency || null,
        amount: v?.amount || null,
        docId: v?.docId || null,
        instructionId: v?.instructionId || null,
        user: v?.user || null,
        invAccess: v?.invAccess || null,
        invCancelled: v?.invCancelled || null,
        hasExternalId: v?.hasExternalId || null,
        extFlag: v?.extFlag || null,
        isProcessing: v?.isProcessing || null,
        partnerId: v?.partnerId || null,
        docCategory: v?.docCategory || null,
        country: v?.country
      }))
      data.sort((A: any, B: any) => B.blEventId - A.blEventId)
      return {
        next: null,
        previous: null,
        list: data,
      };
    } catch (e) {
      const error = e as AxiosError;

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);
export const getCoreror = createAsyncThunk(
  'instruction/getCoreror',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `/api/edo-rest-v1/v1/coreor/bl/${payload.blNum}?linerId=${payload?.selectedLinerId}`
      );
      return {
        
        next: null,
        previous: null,
        
       
        list: response.data.containerList.map((v: any) => ({
          ...v,
          containerNo: v?.containerNo || null,
          containerType: v?.containerType || null,
          containerSize: v?.containerSize || null,
          pickupTruckerId:v?.pickupTruckerId || null,
          pickupTruckerName:v?.pickupTruckerName || null,
          truckerCode: v?.truckerCode || null,
          truckerName: v?.truckerName || null,
          releaseDate: v?.releaseDate || null,
          releaseStatus: v?.releaseStatus || null,
          lastFreeDate: v?.lastFreeDate || null,
          releasePin: v?.releasePin || null,
          releaseLoc: v?.releaseLoc || null,
        })),
        
      };
      
    } catch (e) {
      const error = e as AxiosError;

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);


export const getLinerConfigByFieldName = createAsyncThunk(
  "userDetails/getLinerConfigByFieldName",
  async (payload:{
    linerId:string,
    country:string,
    location:string|null,
    instructionId:number|string|null,
    configKey:string|null,
    type:string|null
  }) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v2/v2/config/getLinerConfigList?linerId=${payload.linerId}&country=${payload.country}&type=${payload.type??"INSTRUCTION"}&subtype=${payload.instructionId}`,
      {
        cache:{
          ttl:10 * 60 * 1000
        }
      }
      );
      return {data:response?.data,uniqueKey:payload.configKey};
    } catch (e) {
      const error = e as AxiosError;

      return {};
    }
  }
);


export const getInstructionDocTemplates = createAsyncThunk(
  "userDetails/getInstructionDocTemplates",
  async (payload:{
    linerId:string,
    country:string,
    location:string|null,
    instructionId:number|null,
    configKey:string|null
  }) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v2/v2/config/getLinerConfigList?linerId=${payload.linerId}&country=${payload.country}&type=INSTRUCTION_DOC&subtype=${payload.instructionId}`
      ,{
        cache:{
          ttl:10 * 60 * 1000
        }
      }
      );
      return response.data.map((d:any)=>({
        code:d.edoAppConfigId,
        label:d.fieldType
      }));
    } catch (e) {
      const error = e as AxiosError;
      console.error(error)
      return [];
    }
  }
);

export const submitDemurrageExtension = createAsyncThunk(
  'instruction/submitDemurrageExtension',
  async (payload: any, { dispatch }) => {
    try {
      console.log("payloadd", payload)
      const response = await axiosInstance({
        url: `/api/edo-rest-v2/v2/dndInstruction/submitDeliveryOrderReq`,
        method: 'POST',
        data: {
          instructionType: 820,
          blId: payload?.blId,
          requestedPartnerId: payload?.requestedPartnerId,
          country: payload?.country,
          // extFlag: payload?.extFlag,
          customerEmailId: payload?.senderEmail,
          remarks: payload?.remarks,
          userRemarks: payload?.userRemarks,
          status: payload?.status,
          dndInstructionId: payload?.dndInstructionId,
          extensionDoNo:payload?.extensionDoNo,
          containerDetails:
            payload?.country === 'US'
              ? payload.list
                .filter((c: any) => c?.pickupDate)
                .map((v: any) => ({
                  containerPickupId: v?.containerPickupId || null,
                  cntNo: v?.containerNo || null,
                  pickupDate: v?.pickupDate || null,
                  truckerCode: v?.truckerCode || null,
                  truckerName: v?.truckerName || null,
                  truckerId: v?.truckerId || null,
                  pickupLocation: v?.pickupLocation || null,
                  internalCode: v?.internalCode || null

                }))
              : payload.list.map((v: any) => ({
                containerPickupId: v?.containerPickupId || null,
                cntNo: v?.containerNo || null,
                pickupDate: v?.pickupDate || null,
                truckerCode: v?.truckerCode || null,
                truckerName: v?.truckerName || null,
                truckerId: v?.truckerId || null,
                pickupLocation: v?.pickupLocation || null,
                internalCode: v?.internalCode || null,
                extensionFor: v?.extensionFor || null
              })),

          releaseType: payload?.releaseType,

          dndInstructionAtt:
            payload?.country === 'ZA' || payload?.country === 'GB' || payload?.country === 'TG' || payload?.country === 'KE' || payload?.country === 'JO' || payload?.country === 'UG' || payload?.country == 'TZ' || payload?.country == 'MZ' || payload?.country == 'CD' || payload?.country == 'CM' || payload?.country == 'BJ' || payload?.country =='AE'
              ? payload.docList
                .filter((c: any) => c?.fileName)
                .map((v: any) => ({
                  dndInstructionAttId: v?.dndInstructionAttId || null,
                  docId: v?.docId || null,
                  fileName: v?.fileName || null,
                  serverFilePath: v?.serverPath || null,
                  filePath: v?.filePath || null,
                  tempFileName: v?.tempFileName || null,
                  actionBy: v?.actionBy || null,
                  actionOn: v?.actionOn || null,
                  isVerify: v?.isVerify ? 'Y' : 'N',
                }))
              : [],
          checkList: payload?.checkList.map((x: any) => ({
            ...x,
            "actionBy": x?.linerId,
            "isVerify": x?.check,
            codeId: x?.docId,
            linerId: null,
            check: undefined,
            docId: undefined
          })),
          version: payload?.version,
          groupLevel: payload?.groupLevel,
          linerId: payload?.linerId,
          ...((payload?.unstuffing != '' && payload?.unstuffing != null && payload?.unstuffing != '0')?{unstuffing: payload?.unstuffing} : {})
        },
      });
      if(response?.data?.responseCode?.toLowerCase() === 'success')
      {
        toast.success(response?.data?.responseMsg ?? 'Created successfully!');
      }
      else{
        toast.error(response?.data?.responseMsg);
      }

      //if (payload?.docId) payload?.dispatch?.(getDemurrageView(payload.docId));

      dispatch?.(updateSelectedDateDV({}));

      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      console.log(error,'<<<<<<<<<<<<<<<,error while submitting do request');
      toast.error(error?.message ?? "Network Error")
      return {};
    }
  }
);


export const addDemurrage = createAsyncThunk(
  'instruction/addDemurrage',
  async (payload: any, { dispatch, getState }) => {
    try {
      console.log("payloadd", payload)
      const response = await axiosInstance({
        url: `/api/edo-rest-v2/v2/dndInstruction/submitDemurrageInvoiceRequest`,
        method: 'POST',
        data: {
          blId: payload?.blId,
          requestedPartnerId: payload?.requestedPartnerId,
          country: payload?.country,
          extFlag: payload?.extFlag,
          customerEmailId: payload?.dndInstructionId != null ? payload?.senderEmail : ((getState() as RootState)?.userProfile?.profile?.email ?? payload?.senderEmail),
          remarks: payload?.remarks,
          userRemarks: payload?.userRemarks,
          status: payload?.status,
          dndInstructionId: payload?.dndInstructionId,
          extensionDoNo:payload?.extensionDoNo,
          containerDetails:
            payload?.country === 'US'
              ? payload.list
                .filter((c: any) => c?.pickupDate)
                .map((v: any) => ({
                  containerPickupId: v?.containerPickupId || null,
                  cntNo: v?.containerNo || null,
                  pickupDate: v?.pickupDate || null,
                  truckerCode: v?.truckerCode || null,
                  truckerName: v?.truckerName || null,
                  truckerId: v?.truckerId || null,
                  pickupLocation: v?.pickupLocation || null,
                  internalCode: v?.internalCode || null

                }))
              : payload.list.map((v: any) => ({
                containerPickupId: v?.containerPickupId || null,
                cntNo: v?.containerNo || null,
                pickupDate: v?.pickupDate || null,
                truckerCode: v?.truckerCode || null,
                truckerName: v?.truckerName || null,
                truckerId: v?.truckerId || null,
                pickupLocation: v?.pickupLocation || null,
                internalCode: v?.internalCode || null,
                extensionFor: v?.extensionFor || null
              })),

          releaseType: payload?.releaseType,

          dndInstructionAtt:
            payload?.country === 'ZA' || payload?.country === 'AO' || payload?.country === 'GB' || payload?.country === 'TG' || payload?.country === 'CI' || payload?.country === 'KE' || payload?.country === 'JO' || payload?.country === 'UG' || payload?.country == 'TZ' || payload?.country == 'MZ' ||  payload?.country == 'LK' || payload?.country == 'CD' || payload?.country == 'CM' || payload?.country == 'BJ' || payload?.country =='AE'
              ? payload.docList
                .filter((c: any) => c?.fileName)
                .map((v: any) => ({
                  dndInstructionAttId: v?.dndInstructionAttId || null,
                  docId: v?.docId || null,
                  fileName: v?.fileName || null,
                  serverFilePath: v?.serverPath || null,
                  filePath: v?.filePath || null,
                  tempFileName: v?.tempFileName || null,
                  actionBy: v?.actionBy || null,
                  actionOn: v?.actionOn || null,
                  isVerify: v?.isVerify ? 'Y' : 'N',
                }))
              : [],
          checkList: payload?.checkList.map((x: any) => ({
            ...x,
            "actionBy": x?.linerId,
            "isVerify": x?.check,
            codeId: x?.docId,
            linerId: null,
            check: undefined,
            docId: undefined
          })),
          version: payload?.version,
          groupLevel: payload?.groupLevel,
          linerId: payload?.linerId,
          ...((payload?.unstuffing != '' && payload?.unstuffing != null && payload?.unstuffing != '0')?{unstuffing: payload?.unstuffing} : {})
        },
      });
      if(response?.data?.responseCode?.toLowerCase() === 'success')
      {
        toast.success(response?.data?.responseMsg ?? 'Created successfully!');
      }
      else{
        toast.error(response?.data?.responseMsg);
      }

      //if (payload?.docId) payload?.dispatch?.(getDemurrageView(payload.docId));

      dispatch?.(updateSelectedDateDV({}));

      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      console.log(error,'<<<<<<<<<<<<<<<,error while submitting do request');
      toast.error(error?.message ?? "Network Error")
      return {};
    }
  }
);

export const getDemurrage = createAsyncThunk(
  'instruction/getDemurrage',
  async (payload: any) => {
    try {
      const response = await axiosInstance.post(
        `api/edo-rest-v2/v2/dndInstruction/getNonReleaseContainerByBlId/${payload?.docId}?linerId=${payload.selectedLinerId}`
      );
      return {
        next: null,
        previous: null,
        list:response.data
          .filter((x: any) =>
            payload?.location === 'instruction'
              ? x?.releaseDate === null || x?.releaseDate === undefined
              : true
          )
          .map((v: any) => ({
            ...v,
            blContainerId: v?.blContainerId || null,
            containerNo: v?.containerNo || null,
            needExtensionFor: v?.extensionFor || null,
            pickupDate: v?.pickupDate || null,
            truckerCode: v?.truckerCode || null,
            truckerName: v?.pickupTruckerName || null,
            truckerId: v?.pickupTruckerId || null,
            pickupLocation: (payload?.showPickupLocationFields? v?.pickupLocation : null) || null,
            internalCode: v?.internalCode || null,
            cntStatus: v?.status || null,
            requestedOn: v?.requestedOn || null,
            extFlag: v?.extFlag || null,
            approvedRejectedOn: v?.approvedRejectedOn || null,
          })),
      };
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);

export const mergeDocList = (
  payloadDocList: any[],
  dropdownDocList: any[],
  attachmentData: any[],
  extensionDocList: any[] = []
): { updatedDocList: any[]; updatedExtensionDocList: any[] } => {

  if (!Array.isArray(payloadDocList)) payloadDocList = [];
  if (!Array.isArray(dropdownDocList) || dropdownDocList.length === 0) {
    return { updatedDocList: payloadDocList, updatedExtensionDocList: [] };
  }
  if (!Array.isArray(attachmentData)) attachmentData = [];

  const dropdownDocId = dropdownDocList.map((i: any) => i.id);

  const dropdownDocs = attachmentData
    .filter((i: any) => dropdownDocId.includes(i.docId))
    .map((e: any) => ({
      rowNumber: crypto.randomUUID(),
      id: e?.docId,
      name: dropdownDocList.find((i: any) => i?.id === e?.docId)?.name,
      m: true,
      isDropDownDoc: true
    }));

  const dropdownDocsForExtension = attachmentData
    .filter((i: any) => dropdownDocId.includes(i.docId))
    .map((e: any) => ({
      rowNumber: crypto.randomUUID(),
      id: e?.docId,
      name: dropdownDocList.find((i: any) => i?.id === e?.docId)?.name,
      m: true,
      isDropDownDoc: true
    }));

  if (Array.isArray(extensionDocList) && extensionDocList.length === 0) {
    return {
      updatedDocList: [...payloadDocList, ...dropdownDocs],
      updatedExtensionDocList: []
    };
  } else {
    return {updatedDocList: [...payloadDocList, ...dropdownDocs],
      updatedExtensionDocList: [...extensionDocList, ...dropdownDocsForExtension]};
  }

};

export const docConfigAndAttData = (
  payloadDocList: any[],
  country: string,
  linerId: any

): any => {

  if (!Array.isArray(payloadDocList) || payloadDocList.length === 0) {
    return {
      dropdownDocList: [],
      docList: [],
      attDataList: []
    };
  }
  const updatedDocList = payloadDocList?.filter((i: any) => (i.isMandatory != "H" && i.isMandatory != "E"))?.map?.((i: any) => ({
    rowNumber: crypto.randomUUID(),
    id: i?.docId,
    name: i.docName,
    m: i.isMandatory == 'Y',
    // m: i.isMandatory === 'H' || i.isMandatory === 'Y',
  }))

  const updatedExtensionDocList = payloadDocList?.filter((i: any) => (i.isMandatory == "E"))?.map?.((i: any) => ({
    rowNumber: crypto.randomUUID(),
    id: i?.docId,
    name: i.docName,
    m: (country == 'ZA' && linerId == '24118' && i?.docId == 309)? false: true,
    isDOExtensionFile: true
    // m: i.isMandatory === 'H' || i.isMandatory === 'Y',
  }))

  const dropdownOptions = payloadDocList?.filter((i: any) => (i.isMandatory == "H"))?.map?.((i: any) => ({
    id: i?.docId,
    name: i.docName,
    m: true,
    isDropDownDoc: true
  }))

  const dropdownDocList = dropdownOptions ?? []
  const extensionDocList = updatedExtensionDocList ?? []

  const docList = updatedDocList ?? []
  const attDataList = (updatedDocList ?? [])?.map((x: any) => ({
    rowNumber: x.rowNumber,
    dndInstructionAttId: null,
    docId: x.id,
    fileName: "",
    verify: false,
    actionBy: "",
    actionOn: "",
    m: x.m,
    ...(x.hasOwnProperty('isDropDownDoc') ? { isDropDownDoc: x.isDropDownDoc } : {})
    // isDropDownDoc: x?.isDropDownDoc
  }))

  const extensionAttDataList = (updatedExtensionDocList ?? [])?.map((x: any) => ({
    rowNumber: x.rowNumber,
    dndInstructionAttId: null,
    docId: x.id,
    fileName: "",
    verify: false,
    actionBy: "",
    actionOn: "",
    m: x.m,
    ...(x.hasOwnProperty('isDropDownDoc') ? { isDropDownDoc: x.isDropDownDoc } : {}),
    ...(x.hasOwnProperty('isDOExtensionFile') ? { isDOExtensionFile: x.isDOExtensionFile } : {})

    // isDropDownDoc: x?.isDropDownDoc
  }))

  return { dropdownDocList, docList, attDataList, extensionDocList, extensionAttDataList }
};


export const getDemurrageView = createAsyncThunk(
  'instruction/getDemurrageView',
  async (payload: any, { dispatch }) => {
    try {

      const docConfigResponse = await axiosCacheInstance.get(
        `/api/edo-rest-v2/v2/common/attachments?countryCode=${payload.country}&linerId=${payload.liner}&instructionType=804`
        , {
          cache: {
            ttl: 10 * 60 * 1000
          }
        })

      const {dropdownDocList, docList, attDataList, extensionDocList, extensionAttDataList} = docConfigAndAttData(docConfigResponse?.data, payload.country, payload.liner)
      const response = await axiosInstance.post(
        `api/edo-rest-v2/v2/dndInstruction/getDemurrageInvoiceRequest/${payload?.docId}?linerId=${payload.selectedLinerId}`
      );
      console.log(response?.data?.dndInstructionAtt,"<<<attachmentttemp")
      console.log(docConfigResponse?.data,'<<<<<<dddd')
      const { updatedDocList, updatedExtensionDocList} = mergeDocList(docList, dropdownDocList, response.data.dndInstructionAtt, extensionDocList)

      const visitedAttId: any[] = [];

      // Determine which doc list to use based on extFlag
      const targetDocList = response?.data?.extFlag == "Y" ? updatedExtensionDocList : updatedDocList;
      
      // Always populate attList based on targetDocList, even if dndInstructionAtt is null
      const attList = targetDocList?.map((x: any) => {
        console.log("ATT_MAPPING ", x, response?.data?.dndInstructionAtt)

        const value = response?.data?.dndInstructionAtt?.find(
          (f: any) => f?.docId === x?.id && !visitedAttId.includes(f?.dndInstructionAttId)
        );
        
        if (value?.dndInstructionAttId) {
          visitedAttId.push(value.dndInstructionAttId);
        }

        return {
          rowNumber: x?.rowNumber,
          dndInstructionAttId: value?.dndInstructionAttId || null,
          docId: x?.id,
          filePath: value?.filePath || null,
          fileName: value?.fileName || null,
          m: x?.m,
          isDropDownDoc: x?.isDropDownDoc,
          isVerify: value?.isVerify == 'Y' || false,
          actionOn: (value?.actionBy ?
            moment(
              moment
                .utc(new Date(value?.actionOn))
                .toDate()
            ).format(getDateTimeFormat().toLocaleUpperCase())
            : null) ?? null,
          actionBy: value?.actionBy || null
        };
      }) ?? [];

      return {
        next: null,
        previous: null,
        data: {
          blId: response?.data?.blId,
          requestedPartnerId: response?.data?.requestedPartnerId,
          customerEmailId: response?.data?.customerEmailId,
          country: response?.data?.country,
          dndInstructionId: response?.data?.dndInstructionId || null,
          extensionDoNo: response?.data?.extensionDoNo,
          requestedPartnerNm: response?.data?.requestedPartnerNm,
          remarks: response?.data?.remarks,
          extFlag: response?.data?.extFlag,
          userRemarks: response?.data?.userRemarks,
          status: response?.data?.status || null,
          groupLevel: response?.data?.groupLevel ?? 0,
          linerDocs: response?.data?.dndInstructionLinerAtt ?? [],
          checkList: response?.data?.checkList?.map((i: any) => ({
            docId: i.codeId,
            check: i.isVerify,
            linerId: i.actionBy,
            actionOn: i.actionOn,
            groupLevel: i.groupLevel,
            checkListId: i.checkListId,
            docType: i.docType,
            instructionId: i.instructionId,
            name: i.codeDesc,
            remarks: i.remarks,
            isMandatory: i.isMandatory,
            checkListUpdated: i.actionOn ? new Date(i.actionOn).toLocaleString() : "",
          })) ?? [],
          list: response?.data?.containerDetails
            ? response?.data?.containerDetails.map((v: any) => ({
              ...v,
              blContainerId: v?.containerPickupId || null,
              containerNo: v?.cntNo || null,
              pickupDate: v?.pickupDate || null,
              needExtensionFor: v?.extensionFor || null,
              truckerCode: v?.truckerCode || null,
              truckerName: v?.truckerName || null,
              truckerId: v?.truckerId || null,
              pickupLocation: v?.pickupLocation || null,
              internalCode: v?.internalCode || null,
            }))
            : [],
          attList: attList,
          blNo: response?.data?.blNo,
          doIntegrationStatus: response?.data?.doIntegrationStatus,
          doIntegrationRemarks: response?.data?.doIntegrationRemarks,
          updatedDocListData: targetDocList,
          dropdownDocList: dropdownDocList,
          isProcessing: response?.data?.isProcessing,
          doReceivedFromApi: response?.data?.doReceivedFromApi,
          unstuffing: response?.data?.unstuffing,
          version:response?.data?.version
        },
      };
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        data: {},
      };
    }
  }
);

export const getDoExtenstionDetails = createAsyncThunk(
  'instruction/getDoExtenstionDetails',
  async (payload: any, { dispatch }) => {
    try {

      const docConfigResponse = await axiosCacheInstance.get(
        `/api/edo-rest-v2/v2/common/attachments?countryCode=${payload.country}&linerId=${payload.liner}&instructionType=${payload.instructionType ?? 820}`
        , {
          cache: {
            ttl: 10 * 60 * 1000
          }
        })

      const {dropdownDocList, docList, attDataList, extensionDocList, extensionAttDataList} = docConfigAndAttDataForExtension(docConfigResponse?.data, payload.country, payload.liner)
      const response = await axiosInstance.post(
        `api/edo-rest-v2/v2/dndInstruction/getDeliveryOrderReq/${payload?.docId}?linerId=${payload.selectedLinerId}`
      );
      const { updatedDocList, updatedExtensionDocList} = mergeDocListForExtension([], dropdownDocList, response.data.dndInstructionAtt, extensionDocList)

      const visitedAttId: any[] = [];

      // Determine which doc list to use based on extFlag
      const targetDocList = updatedExtensionDocList;

      // Always populate attList based on targetDocList, even if dndInstructionAtt is null
      const attList = targetDocList?.map((x: any) => {
        console.log("ATT_MAPPING ", x, response?.data?.dndInstructionAtt)

        const value = response?.data?.dndInstructionAtt?.find(
          (f: any) => f?.docId === x?.id && !visitedAttId.includes(f?.dndInstructionAttId)
        );

        if (value?.dndInstructionAttId) {
          visitedAttId.push(value.dndInstructionAttId);
        }

        return {
          rowNumber: x?.rowNumber,
          dndInstructionAttId: value?.dndInstructionAttId || null,
          docId: x?.id,
          filePath: value?.filePath || null,
          fileName: value?.fileName || null,
          m: x?.m,
          isDropDownDoc: x?.isDropDownDoc,
          isVerify: value?.isVerify == 'Y' || false,
          actionOn: (value?.actionBy ?
            moment(
              moment
                .utc(new Date(value?.actionOn))
                .toDate()
            ).format(getDateTimeFormat().toLocaleUpperCase())
            : null) ?? null,
          actionBy: value?.actionBy || null
        };
      }) ?? [];

      return {
        next: null,
        previous: null,
        data: {
          blId: response?.data?.blId,
          requestedPartnerId: response?.data?.requestedPartnerId,
          customerEmailId: response?.data?.customerEmailId,
          country: response?.data?.country,
          dndInstructionId: response?.data?.dndInstructionId || null,
          extensionDoNo: response?.data?.extensionDoNo,
          requestedPartnerNm: response?.data?.requestedPartnerNm,
          remarks: response?.data?.remarks,
          // extFlag: response?.data?.extFlag,
          userRemarks: response?.data?.userRemarks,
          status: response?.data?.status || null,
          groupLevel: response?.data?.groupLevel ?? 0,
          linerDocs: response?.data?.dndInstructionLinerAtt ?? [],
          checkList: response?.data?.checkList?.map((i: any) => ({
            docId: i.codeId,
            check: i.isVerify,
            linerId: i.actionBy,
            actionOn: i.actionOn,
            groupLevel: i.groupLevel,
            checkListId: i.checkListId,
            docType: i.docType,
            instructionId: i.instructionId,
            name: i.codeDesc,
            remarks: i.remarks,
            isMandatory: i.isMandatory,
            checkListUpdated: i.actionOn ? new Date(i.actionOn).toLocaleString() : "",
          })) ?? [],
          list: response?.data?.containerDetails
            ? response?.data?.containerDetails.map((v: any) => ({
              ...v,
              blContainerId: v?.containerPickupId || null,
              containerNo: v?.cntNo || null,
              pickupDate: v?.pickupDate || null,
              needExtensionFor: v?.extensionFor || null,
              truckerCode: v?.truckerCode || null,
              truckerName: v?.truckerName || null,
              truckerId: v?.truckerId || null,
              pickupLocation: v?.pickupLocation || null,
              internalCode: v?.internalCode || null,
            }))
            : [],
          extensionAttList: attList,
          blNo: response?.data?.blNo,
          doIntegrationStatus: response?.data?.doIntegrationStatus,
          doIntegrationRemarks: response?.data?.doIntegrationRemarks,
          updatedDocListData: targetDocList,
          dropdownDocList: dropdownDocList,
          isProcessing: response?.data?.isProcessing,
          unstuffing: response?.data?.unstuffing,
          version:response?.data?.version
        },
      };
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        data: {},
      };
    }
  }
);

export const getAttachmentsOnly = createAsyncThunk(
  'Instruction/demurrageAttachments',
  async (payload: any, { dispatch }) => {
    if (payload.id == null) return null
    try {

      const docConfigResponse = await axiosInstance.get(
        `/api/edo-rest-v2/v2/common/attachments?countryCode=${payload.country}&linerId=${payload.liner}&instructionType=804`
      )
      const { dropdownDocList, docList, attDataList, extensionDocList, extensionAttDataList } = docConfigAndAttData(docConfigResponse?.data, payload.country, payload.liner)

      const axobj = await axiosInstance.post(
        `api/edo-rest-v2/v2/dndInstruction/getDemurrageInvoiceRequest/${payload.id}?linerId=${payload.selectedLinerId}`
      )

        const { updatedDocList, updatedExtensionDocList } = mergeDocList(docList, dropdownDocList, axobj.data.dndInstructionAtt, extensionDocList)
        const visitedAttId: any[] = [];
        return {
          id: axobj?.data?.dndInstructionId,
          status: axobj?.data?.status,
          level: axobj?.data?.groupLevel ?? 0,
          extFlag: axobj?.data?.extFlag,
          extensionDoNo: axobj?.data?.extensionDoNo,
          version:axobj?.data?.version,

          att:  (axobj?.data?.extFlag == "Y"?updatedExtensionDocList:updatedDocList)?.map((x: any) => {
              // const value = response?.data?.dndInstructionAtt.find(
              const value = axobj?.data?.dndInstructionAtt.find(
                (f: any) => f?.docId === x?.id && !visitedAttId.includes(f?.dndInstructionAttId)
              );
              visitedAttId.push(value?.dndInstructionAttId)
              return {
                rowNumber:x?.rowNumber,
                dndInstructionAttId: value?.dndInstructionAttId || null,
                docId: x?.id,
                filePath: value?.filePath || null,
                fileName: value?.fileName || null,
                m: x?.m,
                isDropDownDoc: x?.isDropDownDoc,
                isVerify: value?.isVerify == 'Y' || false,
                actionOn: (value?.actionBy ?
                  moment(
                    moment
                      .utc(new Date(value?.actionOn))
                      .toDate()
                  ).format(getDateTimeFormat().toLocaleUpperCase())
                  : null) ?? null,
                actionBy: value?.actionBy || null
              };
            })?? [],
          chk: axobj?.data?.checkList?.map((i: any) => ({
            docId: i.codeId,
            check: i.isVerify,
            linerId: i.actionBy,
            actionOn: i.actionOn,
            groupLevel: i.groupLevel,
            checkListId: i.checkListId,
            docType: i.docType,
            instructionId: i.instructionId,
            name: i.codeDesc,
            //linerId:i.linerId,
            remarks: i.remarks,
            isMandatory: i.isMandatory,
            checkListUpdated: i.actionOn ? moment(
              moment
                .utc(new Date(i.actionOn))
                .toDate()).format(getDateTimeFormat().toLocaleUpperCase()
                ) : '',

          })) ?? [],
          blNo:axobj?.data?.blNo,
          updatedDocListData: axobj?.data?.extFlag == "Y"?updatedExtensionDocList:updatedDocList,
          dropdownDocList: dropdownDocList,
          unstuffing: axobj?.data?.unstuffing

          // docList: docList,
        }
    } catch {
      return null
    }
  }
)

export const getAttachmentsOnlyDOExtension = createAsyncThunk(
  'Instruction/getAttachmentsOnlyDOExtension',
  async (payload: any, { dispatch }) => {
    if (payload.id == null) return null
    try {
      const docConfigResponse = await axiosInstance.get(
        `/api/edo-rest-v2/v2/common/attachments?countryCode=${payload.country}&linerId=${payload.liner}&instructionType=820`
      )
      const { dropdownDocList, docList, attDataList, extensionDocList, extensionAttDataList } = docConfigAndAttDataForExtension(docConfigResponse?.data, payload.country, payload.liner)
      const axobj = await axiosInstance.post(
        `api/edo-rest-v2/v2/dndInstruction/getDeliveryOrderReq/${payload.id}?linerId=${payload.liner}`
      )
        const { updatedDocList, updatedExtensionDocList } = mergeDocListForExtension(docList, dropdownDocList, axobj.data.dndInstructionAtt, extensionDocList)
        const visitedAttId: any[] = [];
        return {
          id: axobj?.data?.dndInstructionId,
          status: axobj?.data?.status,
          level: axobj?.data?.groupLevel ?? 0,
          // extFlag: axobj?.data?.extFlag,
          extensionDoNo: axobj?.data?.extensionDoNo,
          version:axobj?.data?.version,

          att:  (updatedExtensionDocList)?.map((x: any) => {
              // const value = response?.data?.dndInstructionAtt.find(
              const value = axobj?.data?.dndInstructionAtt.find(
                (f: any) => f?.docId === x?.id && !visitedAttId.includes(f?.dndInstructionAttId)
              );
              visitedAttId.push(value?.dndInstructionAttId)
              return {
                rowNumber:x?.rowNumber,
                dndInstructionAttId: value?.dndInstructionAttId || null,
                docId: x?.id,
                filePath: value?.filePath || null,
                fileName: value?.fileName || null,
                m: x?.m,
                isDropDownDoc: x?.isDropDownDoc,
                isVerify: value?.isVerify == 'Y' || false,
                actionOn: (value?.actionBy ?
                  moment(
                    moment
                      .utc(new Date(value?.actionOn))
                      .toDate()
                  ).format(getDateTimeFormat().toLocaleUpperCase())
                  : null) ?? null,
                actionBy: value?.actionBy || null
              };
            })?? [],
          chk: axobj?.data?.checkList?.map((i: any) => ({
            docId: i.codeId,
            check: i.isVerify,
            linerId: i.actionBy,
            actionOn: i.actionOn,
            groupLevel: i.groupLevel,
            checkListId: i.checkListId,
            docType: i.docType,
            instructionId: i.instructionId,
            name: i.codeDesc,
            //linerId:i.linerId,
            remarks: i.remarks,
            isMandatory: i.isMandatory,
            checkListUpdated: i.actionOn ? moment(
              moment
                .utc(new Date(i.actionOn))
                .toDate()).format(getDateTimeFormat().toLocaleUpperCase()
                ) : '',

          })) ?? [],
          blNo:axobj?.data?.blNo,
          updatedDocListData: updatedExtensionDocList,
          dropdownDocList: dropdownDocList,
          unstuffing: axobj?.data?.unstuffing
          // docList: docList,
        }
    } catch {
      return null
    }
  }
)

export const mergeDocListForExtension = (
  payloadDocList: any[],
  dropdownDocList: any[],
  attachmentData: any[],
  extensionDocList: any[] = []
): { updatedDocList: any[]; updatedExtensionDocList: any[] } => {

  if (!Array.isArray(payloadDocList)) payloadDocList = [];
  if (!Array.isArray(extensionDocList)) extensionDocList = [];

  if (!Array.isArray(dropdownDocList) || dropdownDocList.length === 0) {
    return { updatedDocList: [], updatedExtensionDocList: extensionDocList };
  }
  if (!Array.isArray(attachmentData)) attachmentData = [];

  const dropdownDocId = dropdownDocList.map((i: any) => i.id);

  const dropdownDocsForExtension = attachmentData
    .filter((i: any) => dropdownDocId.includes(i.docId))
    .map((e: any) => ({
      rowNumber: crypto.randomUUID(),
      id: e?.docId,
      name: dropdownDocList.find((i: any) => i?.id === e?.docId)?.name,
      m: true,
      isDropDownDoc: true
    }));

    return {
      updatedDocList: [],
      updatedExtensionDocList: [...extensionDocList, ...dropdownDocsForExtension]
    };

};

export const docConfigAndAttDataForExtension = (
  payloadDocList: any[],
  country: string,
  linerId: any

): any => {

  if (!Array.isArray(payloadDocList) || payloadDocList.length === 0) {
    return {
      dropdownDocList: [],
      docList: [],
      attDataList: []
    };
  }
  // const updatedDocList = payloadDocList?.filter((i: any) => (i.isMandatory != "H" && i.isMandatory != "E"))?.map?.((i: any) => ({
  //   rowNumber: crypto.randomUUID(),
  //   id: i?.docId,
  //   name: i.docName,
  //   m: i.isMandatory == 'Y',
  //   // m: i.isMandatory === 'H' || i.isMandatory === 'Y',
  // }))

  const updatedExtensionDocList = payloadDocList?.filter((i: any) => (i.isMandatory != "H" && i.isMandatory != "E"))?.map?.((i: any) => ({
    rowNumber: crypto.randomUUID(),
    id: i?.docId,
    name: i.docName,
    m: i.isMandatory == 'Y',
    // isDOExtensionFile: true
    // m: i.isMandatory === 'H' || i.isMandatory === 'Y',
  }))

  const dropdownOptions = payloadDocList?.filter((i: any) => (i.isMandatory == "H"))?.map?.((i: any) => ({
    id: i?.docId,
    name: i.docName,
    m: true,
    isDropDownDoc: true
  }))

  const dropdownDocList = dropdownOptions ?? []
  const extensionDocList = updatedExtensionDocList ?? []

  // const docList = updatedDocList ?? []
  // const attDataList = (updatedDocList ?? [])?.map((x: any) => ({
  //   rowNumber: x.rowNumber,
  //   dndInstructionAttId: null,
  //   docId: x.id,
  //   fileName: "",
  //   verify: false,
  //   actionBy: "",
  //   actionOn: "",
  //   m: x.m,
  //   ...(x.hasOwnProperty('isDropDownDoc') ? { isDropDownDoc: x.isDropDownDoc } : {})
  //   // isDropDownDoc: x?.isDropDownDoc
  // }))

  const docList: any = []
   const attDataList: any = []

  const extensionAttDataList = (updatedExtensionDocList ?? [])?.map((x: any) => ({
    rowNumber: x.rowNumber,
    dndInstructionAttId: null,
    docId: x.id,
    fileName: "",
    verify: false,
    actionBy: "",
    actionOn: "",
    m: x.m,
    ...(x.hasOwnProperty('isDropDownDoc') ? { isDropDownDoc: x.isDropDownDoc } : {})
    // ...(x.hasOwnProperty('isDOExtensionFile') ? { isDOExtensionFile: x.isDOExtensionFile } : {})

    // isDropDownDoc: x?.isDropDownDoc
  }))

  return { dropdownDocList, docList, attDataList, extensionDocList, extensionAttDataList }
};


export const getDeliveryOrderDataForExtension = createAsyncThunk(
  'instruction/getDeliveryOrderDataForExtension',
  async (payload: any, { dispatch }) => {
    try {

      const response = await axiosInstance.post(
        `api/edo-rest-v2/v2/dndInstruction/getDeliveryOrderDataForExtension/${payload?.blId}?linerId=${payload.selectedLinerId}`
      );
      console.log(response.data, "responsedata")
      return response.data

    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        data: {},
      };
    }
  }
);

export const getDeliveryOrderDataForExtensionNew = createAsyncThunk(
  'instruction/getDeliveryOrderDataForExtensionNew',
  async (payload: any, { dispatch }) => {
    try {

      const response = await axiosInstance.post(
        `api/edo-rest-v2/v2/dndInstruction/getDeliveryOrderDataForExtension/${payload?.blId}?linerId=${payload.selectedLinerId}`
      );
      console.log(response.data, "responsedata")
      return response.data

    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        data: {},
      };
    }
  }
);

export const getPaymentReceiptsForDO = createAsyncThunk(
  'instruction/getPaymentReceiptsForDO',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `/api/edo-rest-v2/v2/payment/getPaymentReceipts?blId=${payload?.blId}&linerId=${payload.selectedLinerId}`
      );
      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);
      return [];
    }
  }
);

export const checkUnpaidInvoices = createAsyncThunk(
  'instruction/checkUnpaidInvoices',
  async ({ blid, country, linerId, location }: { blid: any, country: string, linerId: any, location: any }, { getState }: any) => {
    try {
      const data = (await axiosInstance.get(
        `api/edo-rest-v2/v2/pop/customer/unpaidInvoices?blId=${blid}&isCredit=N&country=${country}&linerId=${linerId}&location=${location}`,
      ))?.data
      return data?.length == 0

    } catch (e: any) {
      return false
    }
  }
)

export const getUnpaidInvoice = createAsyncThunk(
  'instruction/getUnpaidData',
  async ({crrPopAttStop, blid, country, linerId, location }: { crrPopAttStop:string,blid: any, country: string, linerId: any, location: any }, { getState }: any) => {
    try {
      const data = (await axiosInstance.get(
        `api/edo-rest-v2/v2/pop/customer/unpaidInvoices?blId=${blid}&isCredit=N&country=${country}&linerId=${linerId}&location=${location}`,
      ))?.data

      const state: RootState = getState()
      let paymentData: Array<{ id: number, number: string, amount: number, ccy: string }> = []
      if (crrPopAttStop == "Y") {
        paymentData = (await axiosInstance.get(
          `api/edo-rest-v2/v2/pop/customer/getPaymentsWithoutAttachments?blId=${blid}&&isCredit=N&&country=${country}&linerId=${linerId}&location=${location}`,
        )).data.map((x: any) => ({
          number: x.pmtReference,
          id: x.pmtId,
          ccy: x.currency,
          amount: x.pmtAmt,
        }))
      }

      if (data?.statusCode) throw { message: `Error: Status code ${data?.statusCode}` }

      return {
        attachment: paymentData,
        unpaid: data.map((item: any) => ({
          invno: item.invno ?? '',
          invid: item.invid ?? null,
          ccy: item.invoiceaccess == 'Y' ? item.invcurr ?? '' : '',
          amount: item.invoiceaccess == 'Y' ? item.invamt ?? null : null,
          invtype: item.invtype ?? '',
          invoiceAccess: item.invoiceaccess,
          localamount: item.localamt,
          localccy: item.localccy ?? '',
        })).sort(function (a: any, b: any) { return b.ccy.localeCompare(a.ccy); })
      }
    } catch (e: any) {
      console.error('Unpaid API Error: ', e.message)
      toast.error(e.message)
      return {
        err: true,
        unpaid: [{}],
        attachment: [{}]
      }
    }
  }
)

export const getPaymentsWithoutPOP = createAsyncThunk(
  'instruction/getPaymentsWithoutPOP',
  async ({ blid }: { blid: any }) => {
  }
)

export const getReleasePOPDetails = createAsyncThunk(
  'instruction/getReleasePOPDetails',
  async ({ blid, country }: { blid: any, country: string }) => {
    try {
      const data = (await axiosInstance.get(
        `api/edo-rest-v2/v2/pop/liner/AllInvoices?blId=${blid}&&country=${country}`,
      ))?.data
      if (data?.statusCode) throw { message: `Error: Status code ${data?.statusCode}` }
      return data.map((item: any) => ({
        invid: item.invid ?? 0,
        invno: item.invno ?? '',
        ccy: item.invcurr ?? '',
        amount: item.invamt ?? null,
        invtype: item.invtype ?? '',
        invref: item.pmtreference ?? '',
        invatt: item.filePath?.split('/')?.pop()?.substring(8) ?? '',
        invstatus: item.pmtstatus ?? '',
        hyperlink: item.filePath ?? '',
        invoicestatus: item.invstatus ?? null,
        pymtId: item.pmtid ?? null,
        popAttachments: item.popAttachments ?? [],
      })).sort(function (a: any, b: any) { return b.invref.localeCompare(a.invref); })
    } catch (e: any) {
      console.error('POP Liner API Error: ', e.message)
      return []
    }
  }
)

export const getAllInvoicesForBl = createAsyncThunk(
  'instruction/getAllInvoicesForBl',
  async (payload: any) => {
    try {
      const { blid, country, linerId } = (payload ?? {}) as { blid: any, country: string, linerId: any }
      const data = (await axiosInstance.get(
        `api/edo-rest-v2/v2/pop/bl/allInvoices?blId=${blid}&country=${country}&linerId=${linerId}`,
      ))?.data
      if (data?.statusCode) throw { message: `Error: Status code ${data?.statusCode}` }
      return data.map((item: any) => ({
        invid: item.invid ?? 0,
        invno: item.invno ?? '',
        ccy: item.invcurr ?? '',
        amount: item.invamt ?? null,
        invtype: item.invtype ?? '',
        invref: item.pmtreference ?? '',
        invatt: item.filePath?.split('/')?.pop()?.substring(8) ?? '',
        invstatus: item.pmtstatus ?? '',
        hyperlink: item.filePath ?? '',
        invoicestatus: item.invstatus ?? null,
        pymtId: item.pmtid ?? null,
        popAttachments: item.popAttachments ?? [],
      })).sort(function (a: any, b: any) { return b.invref.localeCompare(a.invref); })
    } catch (e: any) {
      console.error('POP Liner API Error: ', e.message)
      return []
    }
  }
)

export const approveRejectDemurrage = createAsyncThunk(
  'instruction/approveDemurrage',
  async (payload: any) => {
    try {
      /*
      const response = await axiosInstance.patch(
        //`/api/edo-rest-v1/v1/carrierHaulage/${payload.carrierHaulageId}`,
        `/api/edo-rest-v1/v1/dndInstruction/approveRejectDND${docId}`
      );
      return {
        next: null,
        previous: null,
        data: {
          blId: response.data.blId,
          requestedPartnerId: 82,
          customerEmailId: response.data.customerEmailId,
          dndInstructionId: docId,
          requestedPartnerNm: response.data.requestedPartnerNm,
          // customerEmailId: payload?.customerEmailId,
          list: response.data.containerDetails.map((v: any) => ({
            ...v,
            blContainerId: v?.containerPickupId || null,
            containerNo: v?.cntNo || null,
            pickupDate: v?.pickupDate || null,
            truckerCode: '',
            
          })),
        },
      };*/
      const response = await axiosInstance({
        url: `/api/edo-rest-v1/v1/dndInstruction/approveRejectDND`,
        method: 'POST',
        data: {
          blId: payload?.blId,
          requestedPartnerId: payload?.requestedPartnerId,
          customerEmailId: payload?.senderEmail,
          dndInstructionId: payload?.dndInstructionId || null,
          requestedPartnerNm: payload?.requestedPartnerNm || null,
          remarks: payload?.remarks,
          status: payload?.status,
          containerDetails: [],
        },
      });

      //  toast.success('Created successfully!', {
      // style: {
      //  color: 'white',
      //  },
      //  });

      if (payload?.docId) payload?.dispatch?.(getDemurrageView(payload.docId));

      payload?.dispatch?.(updateSelectedDateDV({}));

      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);
      return {};
    }
  }
);

export const getTrukerNameList = createAsyncThunk(
  'instruction/getTrukerNameList',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `/api/edo-rest-v2/v2/trucker/getTruckerDetailsByLinerIdAndCountryCode?truckerName=${payload?.name}&linerId=${payload?.linerId}&countryCode=${payload?.country}`
      );
      if (response?.data && response?.data !== '') {
        return response?.data?.map((c: any) => {
          return {
            ...c,
            label: c?.truckerName,
            value: c?.truckerName,
          };
        });
      } else {
        return [];
      }
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);


export const getCFSNameList = createAsyncThunk(
  'instruction/getCFSNameList',
  async (payload: any) => {
    try {
      //?name=${payload?.name}&country=${payload?.country}`
      const response = await axiosInstance.post(
        `api/edo-rest-v2/v2/dndInstruction/getCfsListByName`,
        {
          pickupLocation: payload?.name,
          country: payload?.country
        }
      );
      if (response?.data && response?.data !== '') {
        return response?.data?.map((c: any) => {
          return {
            ...c,
            label: c?.cfsName,
            value: c?.cfsName,
          };
        });
      } else {
        return [];
      }
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);

export const getPickupCFSName = createAsyncThunk(
  'pickUpInstruction/getPickupCFSName',
  async (payload: any) => {
    try {
      //?name=${payload?.name}&country=${payload?.country}`
      const response = await axiosInstance.post(
        `api/edo-rest-v2/v2/dndInstruction/getCfsListByName`,
        {
          pickupLocation: payload?.name,
          country: payload?.country
        }
      );
      if (response?.data && response?.data !== '') {
        return response?.data?.map((c: any) => {
          return {
            ...c,
            label: c?.cfsName,
            value: c?.cfsName,
          };
        });
      } else {
        return [];
      }
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);

export const getCountryConfig = createAsyncThunk(
  'instruction/getCoutryConfig',
  async (payload: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `api/edo-rest-v2/v2/bl/getBlCountryConfig?linerId=${payload.linerId}${payload.instId ? `&instId=${payload.instId}` : ""}&${payload?.import ? `pod=${payload.pod}&fpod=${payload.fpod}` :
          `pol=${payload.pol}&spol=${payload.spol}`}`
        , {
          cache: {
            ttl: 10 * 60 * 1000
          }
        })
      if (response.data.status != 'success' || !response.data?.config) throw Error()
      return response.data?.config.trim()

    } catch (e) {
      return payload.import ? "FPOD" : "SPOL"
    }

  }
)

export const getOBLDetails = createAsyncThunk(
  'instruction/getOBLDetails',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `/api/edo-rest-v2/v2/coreor/blDoc/${payload?.blNumber}?linerId=${payload?.selectedLinerId}`
      );
      /* response?.data?.blJourneyList?.sort((a: any, b: any) => {
        return a.blJourneyId - b.blJourneyId;
      }); */
      return response.data;
    } catch (e) {
      const error = e as AxiosError;

      return {};
    }
  }
);

export const getOBLForOverStay = createAsyncThunk(
  'overstay/getOBLDetails',
  async (payload: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v2/v2/coreor/blDoc/${payload?.blNumber}?linerId=${payload?.selectedLinerId}`
        , {
          cache: {
            ttl: 1000 * 5
          }
        }
      );
      response?.data?.blJourneyList?.sort((a: any, b: any) => {
        return a.blJourneyId - b.blJourneyId;
      });
      return response.data;
    } catch (e) {
      const error = e as AxiosError;

      return {};
    }
  }
);

export const getOBLForInvoiceRequest = createAsyncThunk(
  'instruction/getOBLForInvoiceRequest',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `/api/edo-rest-v2/v2/coreor/blDoc/${payload?.blNumber}?linerId=${payload?.selectedLinerId}`
      );
      response?.data?.blJourneyList?.sort((a: any, b: any) => {
        return a.blJourneyId - b.blJourneyId;
      });
      return response.data;
    } catch (e) {
      const error = e as AxiosError;

      return {};
    }
  }
);

export const getCarrierHaulage = createAsyncThunk(
  'instruction/getOBLDetails',
  async (blNumber: any) => {
    try {
      const response = { data: '' };

      return response.data;
    } catch (e) {
      const error = e as AxiosError;

      return {};
    }
  }
);

export const addCarrierHaulage = createAsyncThunk(
  'instruction/addCarrierHaulage',
  async (payload: any) => {
    try {
      const response = await axiosInstance.post(
        `api/edo-rest-v1/v1/carrierHaulage`, payload
      );

      return response.data;
    } catch (e) {
      const error = e as AxiosError;

      return {};
    }
  }
);

export const getInvoiceChange = createAsyncThunk(
  'instruction/getInvoiceChange',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `api/edo-rest-v2/v2/bp/${payload?.docId}?linerId=${payload?.selectedLinerId}`
      );
      return {
        taxId: response?.data?.taxId || null,
        blId: response?.data?.blId || null,
        masterPartnerId: response?.data?.masterPartnerId,
        standingInstructionId: 1,
        email: response?.data?.emailId || null,
        contactNo: response?.data?.contactNo || null,
        address: response?.data?.address || null,
        invChangegAccessList: response?.data?.invChangegAccessList || [],
        status: response?.data?.status,
        remarks: response?.data?.remarks,
        requestedpartnernm: response?.data?.requestedpartnernm || null,
        poReference: response?.data?.poReference || null,
        country: response?.data?.country || 'US',
        returnType: response?.data?.returnType || null,
        matchCodeList: response?.data?.matchCodeList || [],
        matchCode: response?.data?.matchCode,
        customerCode: response?.data?.customerCode,
        userRemarks: response?.data?.userRemarks,
        blNo: response?.data?.blNo,
        shipmentType: response?.data?.shipmentType,
        instructionType: response?.data?.instructionType
      };
    } catch (e) {
      const error = e as AxiosError;

      return {};
    }
  }
);

export const getInvoiceChangeForExport = createAsyncThunk(
  'instruction/getInvoiceChangeForExport',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `api/edo-rest-v2/v2/bp/getInvoiceChangeInstructionById/${payload?.docId}?linerId=${payload?.selectedLinerId}`
      );
      return {
        taxId: response?.data?.taxId || null,
        blId: response?.data?.blId || null,
        masterPartnerId: response?.data?.masterPartnerId,
        standingInstructionId: 1,
        email: response?.data?.emailId || null,
        contactNo: response?.data?.contactNo || null,
        address: response?.data?.address || null,
        invChangegAccessList: response?.data?.invChangegAccessList || [],
        status: response?.data?.status,
        remarks: response?.data?.remarks,
        requestedpartnernm: response?.data?.requestedpartnernm || null,
        poReference: response?.data?.poReference || null,
        country: response?.data?.country || 'US',
        returnType: response?.data?.returnType || null,
        matchCodeList: response?.data?.matchCodeList || [],
        matchCode: response?.data?.matchCode,
        customerCode: response?.data?.customerCode,
        userRemarks: response?.data?.userRemarks,
        blNo: response?.data?.blNo,
        shipmentType: response?.data?.shipmentType,
        instructionType: response?.data?.instructionType
      };
    } catch (e) {
      const error = e as AxiosError;

      return {};
    }
  }
);

export const fetchCompanyDetailsForAgentDelegation = createAsyncThunk(
  'agentNomination/fetchCompanyDetailsForAgentDelegation',
  async (state: any, { dispatch }) => {
    const csrfMeta =
      document.querySelector<HTMLMetaElement>("meta[name='_csrf']");
    try {
      const response = await axiosInstance.post(
        `/api/user-management/v1/customer/findCustomerByTaxId?countryCode=${state.country}&taxId=${state.taxId}`,
        {
          'X-CSRF-TOKEN': csrfMeta?.content || '',
          'Content-Type': 'application/x-www-form-urlencoded',
          headers: {
            Authorization:
              'Bearer jmVm90UwpC5gNPBYiEEMlFmwq9HKo524YxxVWz43FrAWvELEUzSxzsUSYGWwCA8WmvYwNoqdKhlFBehn6n7IkPv0pq9Y9wRVx90fTegJtUCcBmGLLhyEyLj6ZlXle1JAlDatIiOUurZI6CquQJTQ5ajuduAQvo0HswRERfsikOZ2skYj6g4RKCUK8dEPQUgr73pDIL3tjfuQkcTSKBcCvT10LQZpCzLodVON3lj6Sa3IYFz2xE1JUhb6nev',
          },
        }
      );
      dispatch(updateAgentPartnerId(response.data));
      if (!response.data) {
        toast.error(
          'Entered partner is not available on the ODeX, Kindly request Partner to get registered on the ODeX'
        );
      }

      //dispatch(updateCompanyName(response.data.data[0].company_name));
      //dispatch(updateAddress(response.data.data[0].full_address));
      return response.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
);

export const getInstructionTypes = createAsyncThunk(
  'pymtModedropdown/getInstructionTypes',
  async ({ partnerCountry, linerId, imex, language }: { partnerCountry: any, linerId: any, imex: "import" | "export", language: string }, { dispatch, getState }: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=${language ?? "EN"}&codeType=${imex == "import" ? 'INST_TYPE' : 'INST_TYPE_EXP'}&linerId=${linerId}&countryCode=${partnerCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          },
          headers: {
            Authorization:
              'Bearer jmVm90UwpC5gNPBYiEEMlFmwq9HKo524YxxVWz43FrAWvELEUzSxzsUSYGWwCA8WmvYwNoqdKhlFBehn6n7IkPv0pq9Y9wRVx90fTegJtUCcBmGLLhyEyLj6ZlXle1JAlDatIiOUurZI6CquQJTQ5ajuduAQvo0HswRERfsikOZ2skYj6g4RKCUK8dEPQUgr73pDIL3tjfuQkcTSKBcCvT10LQZpCzLodVON3lj6Sa3IYFz2xE1JUhb6nev',
          },
        }
      );
      let index = 0;
      const instructionTypes = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
        index: index++,
      }));

      dispatch(updateInstructionTypes(instructionTypes));
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);




export const getReportTypes = createAsyncThunk(
  'reportDashboard/getReportTypes',
  async ({ partnerCountry, linerId }: any) => {

    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=REPORT_TYPE&linerId=${linerId}&countryCode=${partnerCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          },
          headers: {
            Authorization:
              'Bearer jmVm90UwpC5gNPBYiEEMlFmwq9HKo524YxxVWz43FrAWvELEUzSxzsUSYGWwCA8WmvYwNoqdKhlFBehn6n7IkPv0pq9Y9wRVx90fTegJtUCcBmGLLhyEyLj6ZlXle1JAlDatIiOUurZI6CquQJTQ5ajuduAQvo0HswRERfsikOZ2skYj6g4RKCUK8dEPQUgr73pDIL3tjfuQkcTSKBcCvT10LQZpCzLodVON3lj6Sa3IYFz2xE1JUhb6nev',
          },
        }
      );
      let index = 0;
      const reportType = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
        index: index++,
      }));
      return reportType
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);
    }
  }
);
export const retriggerInvoice = createAsyncThunk(
  'reportDashboard/retriggerInvoice',
  async (payload: any) => {
    try {
      const response = await axiosInstance.post(
        `/api/edo-rest-v2/v2/invoice/reTriggerBkavCommand`,

        payload

      );
      return response
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);
    }
  }
);
export const getInvoiceChangeTypes = createAsyncThunk(
  'invoiceChange/getInvoiceChangeTypes',
  async ({ partnerCountry, linerId }: any) => {

    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=INV_CHANGE_TYPE&linerId=${linerId}&countryCode=${partnerCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          },
          headers: {
            Authorization:
              'Bearer jmVm90UwpC5gNPBYiEEMlFmwq9HKo524YxxVWz43FrAWvELEUzSxzsUSYGWwCA8WmvYwNoqdKhlFBehn6n7IkPv0pq9Y9wRVx90fTegJtUCcBmGLLhyEyLj6ZlXle1JAlDatIiOUurZI6CquQJTQ5ajuduAQvo0HswRERfsikOZ2skYj6g4RKCUK8dEPQUgr73pDIL3tjfuQkcTSKBcCvT10LQZpCzLodVON3lj6Sa3IYFz2xE1JUhb6nev',
          },
        }
      );
      const invoiceChangeType = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc
      }));
      return invoiceChangeType
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);
    }
  }
);

export const getInvoiceChangeTypesForExport = createAsyncThunk(
  'invoiceChange/getInvoiceChangeTypesForExport',
  async ({ partnerCountry, linerId }: any) => {

    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=INV_CHANGE_TYPE_EXPORT&linerId=${linerId}&countryCode=${partnerCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          },
        }
      );
      const invoiceChangeType = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc
      }));
      return invoiceChangeType
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);
    }
  }
);


export const getPartyListByBlId = createAsyncThunk(
  'agentDelegation/getPartyListByBlId',
  async (blNumber: any, { dispatch }) => {
    try {
      const response = await axiosInstance.get(
        `/api/edo-rest-v2/v2/bl/agentDelegation/${AESDecrypt(blNumber)}`,
        {
          headers: {
            Authorization:
              'Bearer jmVm90UwpC5gNPBYiEEMlFmwq9HKo524YxxVWz43FrAWvELEUzSxzsUSYGWwCA8WmvYwNoqdKhlFBehn6n7IkPv0pq9Y9wRVx90fTegJtUCcBmGLLhyEyLj6ZlXle1JAlDatIiOUurZI6CquQJTQ5ajuduAQvo0HswRERfsikOZ2skYj6g4RKCUK8dEPQUgr73pDIL3tjfuQkcTSKBcCvT10LQZpCzLodVON3lj6Sa3IYFz2xE1JUhb6nev',
          },
        }
      );
      dispatch(updateBLPartyList(response.data.list));
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const fetchAddressSuggestions2: any = createAsyncThunk(
  'registrationCompany/fetchAddressSuggestions2',
  async (payload: any) => {
    try {
      if (payload?.text) {
        if (payload?.country !== null) {
          const response = await axiosInstance.get(
            `/api/user-management/places/v0/indexes/explore.place.Esri/search/suggestions?text=${payload?.text}&filterCountries=${payload?.country}&language=en-US`
          );
          return response.data;
        } else {
          const response = await axiosInstance.get(
            `/api/user-management/places/v0/indexes/explore.place.Esri/search/suggestions?text=${payload?.text}`
          );
          return response.data;
        }
      }
      return [];
    } catch (error) {
      console.error(error);

      return [];
    }
  }
);

/*----------------------------------------------------------
RETURN INSTRUCTION 
------------------------------------------------------------*/

export const getReturnView = createAsyncThunk(
  'instruction/getReturnView',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `api/edo-rest-v1/v1/return/getReturnDetails?id=${payload?.docId}?linerId=${payload?.selectedLinerId}`
      );

      return {
        next: null,
        previous: null,
        data: {
          blId: response?.data?.blId,
          returnInstructionId: response?.data?.returnInstructionId,
          remarks: response?.data?.remarks,
          rejectionRemarks: response?.data?.rejectionRemarks,
          status: response?.data?.status || null,
          // customerEmailId: payload?.customerEmailId,
          list: response?.data?.containerDetails.map((v: any) => ({
            ...v,
            blContainerId: v?.containerReturnId || null,
            containerNo: v?.containerNo || null,
            pickupDate: v?.plannedReturnDate || null,
            // truckerCode: '',
            returnLocation: v?.returnLocation || '',
          })),
        },
      };
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);

export const getReturnContainer = createAsyncThunk(
  'instruction/getReturnContainer',
  async (payload: any) => {
    try {
      const response = await axiosInstance.post(
        `api/edo-rest-v1/v1/return/getNonReturnContainerByBlId/${payload?.docId}?linerId=${payload?.selectedLinerId}`
      );

      return {
        next: null,
        previous: null,
        list: response?.data?.map((v: any) => ({
          ...v,
          blContainerId: v?.blContainerId || null,
          containerNo: v?.containerNo || null,
          pickupDate: v?.pickupDate || null,
          returnLocation: v?.returnLocation || '',
        })),
      };
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);

export const addReturnInstruction = createAsyncThunk(
  'instruction/addReturnInstruction',
  async (payload: any) => {
    try {
      const response = await axiosInstance({
        url: `/api/edo-rest-v1/v1/return/saveReturnDetails`,
        method: 'POST',
        data: {
          blId: payload?.blId,
          remarks: payload?.remarks,
          rejectionRemarks: payload?.rejectionRemarks,
          containerDetailsForReturnInst: payload.list.map((v: any) => ({
            containerNo: v?.containerNo || null,
            plannedReturnDate: v?.pickupDate || null,
            returnLocation: v?.returnLocation || null,
          })),
        },
      });

      //  toast.success('Created successfully!', {
      // style: {
      //  color: 'white',
      //  },
      //  });

      if (payload?.docId) payload?.dispatch?.(getReturnView(payload.docId));

      payload?.dispatch?.(updateReturnSelectedDateDV({}));

      return response.data;
    } catch (e) {
      const error = e as AxiosError;

      return {};
    }
  }
);

export const approveRejectReturn = createAsyncThunk(
  'instruction/approveRejectReturn',
  async (payload: any) => {
    try {
      const response = await axiosInstance({
        url: `/api/edo-rest-v1/v1/return/approveRejectReturn`,
        method: 'POST',
        data: {
          status: payload?.status,
          blId: payload?.blId,
          returnInstructionId: payload?.returnInstructionId,
          rejectionRemarks: payload?.rejectionRemarks,
        },
      });

      if (payload?.docId) payload?.dispatch?.(getReturnView(payload.docId));

      payload?.dispatch?.(updateReturnSelectedDateDV({}));

      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);
      return {};
    }
  }
);

export const getReturnTypeList = createAsyncThunk(
  'invoiceChange/getReturnTypeList',
  async ({ dataCountry, linerId }: { dataCountry: any, linerId: any }, { dispatch, getState }: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=RETURN_LOC&linerId=${linerId}&countryCode=${dataCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          },
          headers: {
            Authorization:
              'Bearer jmVm90UwpC5gNPBYiEEMlFmwq9HKo524YxxVWz43FrAWvELEUzSxzsUSYGWwCA8WmvYwNoqdKhlFBehn6n7IkPv0pq9Y9wRVx90fTegJtUCcBmGLLhyEyLj6ZlXle1JAlDatIiOUurZI6CquQJTQ5ajuduAQvo0HswRERfsikOZ2skYj6g4RKCUK8dEPQUgr73pDIL3tjfuQkcTSKBcCvT10LQZpCzLodVON3lj6Sa3IYFz2xE1JUhb6nev',
          },
        }
      );

      const returnTypeOptions = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
      }));

      dispatch(updateReturnTypeList(returnTypeOptions));
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const getReturnTypeListForExport = createAsyncThunk(
  'invoiceChange/getReturnTypeListForExport',
  async ({ dataCountry, linerId }: { dataCountry: any, linerId: any }, { dispatch, getState }: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=RETURN_LOC_EXPORT&linerId=${linerId}&countryCode=${dataCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          },
        }
      );

      const returnTypeOptions = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
      }));

      dispatch(updateReturnTypeListForExport(returnTypeOptions));
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const getReleaseTypeList = createAsyncThunk(
  'invoiceChange/getReleaseTypeList',
  async ({ partnerCountry, linerId }: { partnerCountry: any, linerId: any }, { dispatch, getState }: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=RELEASE_TYPE&linerId=${linerId}&countryCode=${partnerCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          }
        }
      );

      const releaseTypeOptions = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
      }));
      console.log("releseTypeoptions", releaseTypeOptions)
      dispatch(updateReleaseTypeList(releaseTypeOptions));
      dispatch(updatePickupLocation(releaseTypeOptions));
      dispatch(updateDoExtensionPickupLocation(releaseTypeOptions));
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const extensionTypeList = createAsyncThunk(
  'overstay/extensionTypeList',
  async ({ partnerCountry, linerId }: any, { dispatch }) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=EXTENSION_TYPE&linerId=${linerId}&countryCode=${partnerCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          }
        });

      const extensionTypeOption = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
      }));
      return extensionTypeOption



    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const getUnstuffingTypeList = createAsyncThunk(
  'instruction/getUnstuffingTypeList',
  async ({ partnerCountry, linerId }: any, { dispatch }) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=UNSTUFFING_TYPE&linerId=${linerId}&countryCode=${partnerCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          }
        });
      const unstuffingTypeOption = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
      }));
      return unstuffingTypeOption
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const getLastestExtensionRequest = createAsyncThunk(
  'ExtensionReq/getLastestExtensionRequest',
  async (payload: any, { dispatch }) => {
    try {
      console.log("hereee1234", payload)
      const response = await axiosInstance.get(
        `api/edo-rest-v2/v2/extensionRequest/getLastestExtensionRequest/${payload?.blId}?linerId=${payload.linerId}`,
      )

      return response



    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);
export const getRequestInstructionConfig = createAsyncThunk(
  'getRequest/InstructionConfig',
  async (payload: any) => {
    try {
      console.log("payloaddd", payload)
      const response = await axiosInstance.post(
        'api/edo-rest-v2/v2/common/get-request-instruction-config',
        {
          "liner": Number(AESDecrypt(payload.linerId)),
          "country": payload.country,
          /* "location": "MUM",
          "currency": "INR",
          "requestType": "DO",
          "requestIdentifier": "SOMETHING" */
        }
      );
      return response
    } catch (e) {
      const error = e as AxiosError;
      toast.error(error?.message ?? "Network Error")
      return error;
    }
  }
);

export const getRequestInstructionConfigByType = createAsyncThunk(
  'getRequest/InstructionConfigByType',
  async (payload: any) => {
    try {
      console.log("payloaddd", payload)
      const response = await axiosInstance.post(
        'api/edo-rest-v2/v2/common/get-request-instruction-config',
        {
          "liner": Number(AESDecrypt(payload.linerId)),
          "country": payload.country,
          "requestType": payload.requestType,
          "requestIdentifier": payload.requestIdentifier
        }
      );
      return response
    } catch (e) {
      const error = e as AxiosError;
      toast.error(error?.message ?? "Network Error")
      return error;
    }
  }
);

export const updateIsProcessingFlag = createAsyncThunk(
  'instruction/updateIsProcessingFlag',
  async (payload: any) => {
    try {
      const response = await axiosInstance.post(
        `api/edo-rest-v2/v2/dndInstruction/updateISProcessingFlag?demmurrageId=${payload?.demmurrageId}&blId=${payload?.blId}`
      );
      return response
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const getApprovalLevels = createAsyncThunk(
  'getRequest/getApprovalLevels',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `api/edo-rest-v2/v2/common/getApprovalConfig?partnerId=${payload?.partnerId}&countryCode=${payload?.countryCode}&actionType=${payload?.actionType}`
      );

      if (!response?.data || !Array.isArray(response.data)) {
        return {
          defaultValue: undefined,
          approvalList: []
        };
      }

      const transformedData = response.data
        .map((item: any) => ({
          ...item,
          approvalLevel: (item.approvalLevel || 0) - 1,
          resubmitLevel: (item.resubmitLevel || 0) - 1
        }))
        .filter((item: any) => item.approvalLevel >= 0);

      const defaultItem = transformedData.find(
        (item: any) => item.approvalLevel === payload?.groupLevel
      );

      const defaultValue = defaultItem?.resubmitLevel;

      const approvalList = transformedData
        .filter((item: any) => item.approvalLevel <= payload?.groupLevel)
        .map((item: any) => ({
          label: item.levelName || `Level ${item.approvalLevel}`,
          value: item.approvalLevel
        }));

      return {
        defaultValue,
        approvalList
      };

    } catch (error) {
      console.error('Failed to fetch approval levels:', error);
      return {
        defaultValue: undefined,
        approvalList: []
      };
    }
  }
);

export const getApprovalConfigByInstructionName = createAsyncThunk(
  'getRequest/getApprovalConfigByInstructionName',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `api/edo-rest-v2/v2/common/getApprovalConfigByInstructionName?partnerId=${payload?.partnerId}&countryCode=${payload?.countryCode}&actionType=${payload?.actionType}&name=${payload?.name}`
      );

      if (!response?.data || !Array.isArray(response.data)) {
        return {
          defaultValue: undefined,
          approvalList: []
        };
      }

      const transformedData = response.data
        .map((item: any) => ({
          ...item,
          approvalLevel: (item.approvalLevel || 0) - 1,
          resubmitLevel: (item.resubmitLevel || 0) - 1
        }))
        .filter((item: any) => item.approvalLevel >= 0);

      const defaultItem = transformedData.find(
        (item: any) => item.approvalLevel === payload?.groupLevel
      );

      const defaultValue = defaultItem?.resubmitLevel;

      const approvalList = transformedData
        .filter((item: any) => item.approvalLevel <= payload?.groupLevel)
        .map((item: any) => ({
          label: item.levelName || `Level ${item.approvalLevel}`,
          value: item.approvalLevel
        }));

      return {
        defaultValue,
        approvalList
      };

    } catch (error) {
      console.error('Failed to fetch approval levels:', error);
      return {
        defaultValue: undefined,
        approvalList: []
      };
    }
  }
);
//--------------------------------------------------------------------

export const savePickUpInstruction = createAsyncThunk(
  'pickUpInstruction/savePickUpInstruction',
  async (payload: any) => {
    try {
      const response = await axiosInstance.post(
        '/api/edo-rest-v2/v2/pickup/savePickUpDetails',
        {
          pickUpId: payload?.pickUpId,
          pickUpLoc: payload?.pickUpLoc,
          destuffingTp: payload?.destuffingTp,
          country: payload.country,
          // returnLoc: payload?.returnLoc,
          userRemarks: payload?.userRemark,
          blId: payload?.blId,
          linerId: payload?.linerId,
          pickUpLocationName:payload?.cfsIcdName?.cfsName,
          loiFilePath:payload?.loiFilePath,
          loiFileName:payload?.loiFileName
        }
      );
      toast.success(response?.data?.responseMsg);
    } catch (e) {
      const error = e as AxiosError;
      toast.error(error?.message ?? "Network Error")
      return error;
    }
  }
);

export const getPickUp = createAsyncThunk(
  'instruction/getPickUp',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `api/edo-rest-v2/v2/pickup/viewPickupDetails/${payload.docId}?linerId=${payload?.selectedLinerId}`
      );

      return {
        next: null,
        previous: null,
        data: {
          blId: response?.data?.blId,
          pickUpId: response?.data?.pickUpId,
          returnInstructionId: response?.data?.returnInstructionId,
          userRemarks: response?.data?.userRemarks,
          rejectionRemarks: response?.data?.rejectionRemarks,
          status: response?.data?.status || null,
          //returnLoc: response?.data?.returnLoc,
          destuffingTp: response?.data?.destuffingTp,
          pickUpLoc: response?.data?.pickUpLoc,
          country: response?.data?.country,
          email: response?.data?.emailId,
          blNo: response?.data?.blNo,
          // cfsIcdPartnerId: response?.data?.cfsIcdPartnerId,
          pickUpLocationName: response?.data?.pickUpLocationName,
          loiFilePath: response?.data?.loiFilePath,
          loiFileName: response?.data?.loiFileName
        },
      };
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);

export const approveRejectPickUp = createAsyncThunk(
  'instruction/approveRejectPickUp',
  async (payload: any) => {
    try {
      const response = await axiosInstance({
        url: `/api/edo-rest-v1/v1/pickup/approveRejectPickUp`,
        method: 'POST',
        data: {
          status: payload?.status,
          rejectionRemarks: payload?.rejectRemarks,
          pickUpId: payload?.pickUpId,
          pickUpLoc: payload?.pickUpLoc,
          destuffingTp: payload?.destuffingTp,
          returnLoc: payload?.returnLoc,
          userRemarks: payload?.userRemark,
          emailId: payload?.emailId,
          blId: payload?.blId,
        },
      });

      //  toast.success('Created successfully!', {
      // style: {
      //  color: 'white',
      //  },
      //  });

      if (payload?.docId) payload?.dispatch?.(getDemurrageView(payload.docId));

      payload?.dispatch?.(updateSelectedDateDV({}));

      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);
      return {};
    }
  }
);

export const getPickupList = createAsyncThunk(
  'instruction/getPickupList',
  async ({ partnerCountry, linerId }: { partnerCountry: any, linerId: any }, { dispatch, getState }: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=PICKUP_RELEASE_TYPE&linerId=${linerId}&countryCode=${partnerCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          }
        }
      );

      const releaseTypeOptions = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
      }));

      dispatch(updateReleaseTypeList(releaseTypeOptions));
      dispatch(updatePickupLocation(releaseTypeOptions));
      dispatch(updateDoExtensionPickupLocation(releaseTypeOptions));
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const commonApproveReject = createAsyncThunk(
  'instruction/commonApproveReject',
  async (payload: any, { getState }: any) => {
    try {
      const state: RootState = getState();
      const demurrageInstLinerAttDtls = payload?.demurrageInstLinerAttDtls?.toSorted?.(
        (x: any) => x.docId == 206 ? -1 : 0
      )

      const response = await axiosInstance({
        url: `/api/edo-rest-v2/v2/common/approveRejectInstructions`,
        method: 'POST',
        data: {
          instructionId: payload?.instructionId || null,
          instructionType: payload?.instructionType || null,
          country: payload?.country ?? null,
          linerRemarks: payload?.linerRemarks || null,
          customerRemarks: payload?.customerRemarks || null,
          status: payload?.status || null,
          emailTo: payload?.emailTo || null,
          matchCode: payload?.matchCode || null,
          customerCode: payload?.customerCode || null,
          accessList: payload?.accessList || null,
          requestType: payload?.requestType || '',
          requestedPartnerId: payload?.requestedPartnerId || null,
          blId: payload?.blId || null,
          isVerify: payload?.isVerify ?? null,
          groupLevel: payload?.groupLevel ?? null,
          actionBy: payload?.actionBy ?? null,
          checkList: payload.checkList ?? null,
          demurrageInstLinerAttDtls: demurrageInstLinerAttDtls ?? null,
          linerId: +state.navbarTop.linerId,
          cfsPartnerId: payload?.cfsPartnerId,
          emptyYardPartnerId: payload?.emptyYardPartnerId,
          nextLevel: payload?.nextLevel >= 0 ? payload?.nextLevel : null,
          pickUpLocationName:payload?.pickUpLocationName || '',
          version:payload?.version,
          ...((payload?.unstuffing != '' && payload?.unstuffing != null && payload?.unstuffing != '0')?{unstuffing: payload?.unstuffing} : {}),
          ...(payload?.shipmentType ? { shipmentType: payload?.shipmentType } : {})
        },
      });
      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);
      return {};
    }
  }
);

export const approveRejectDoExtension = createAsyncThunk(
  'instruction/approveRejectDoExtension',
  async (payload: any, { getState }: any) => {
    try {
      const state: RootState = getState();
      const demurrageInstLinerAttDtls = payload?.demurrageInstLinerAttDtls?.toSorted?.(
        (x: any) => x.docId == 206 ? -1 : 0
      )

      const response = await axiosInstance({
        url: `/api/edo-rest-v2/v2/common/approveRejectContainerReleaseAndExtension`,
        method: 'POST',
        data: {
          instructionId: payload?.instructionId || null,
          instructionType: payload?.instructionType || null,
          country: payload?.country ?? null,
          linerRemarks: payload?.linerRemarks || null,
          customerRemarks: payload?.customerRemarks || null,
          status: payload?.status || null,
          emailTo: payload?.emailTo || null,
          matchCode: payload?.matchCode || null,
          customerCode: payload?.customerCode || null,
          accessList: payload?.accessList || null,
          requestType: payload?.requestType || '',
          requestedPartnerId: payload?.requestedPartnerId || null,
          blId: payload?.blId || null,
          isVerify: payload?.isVerify ?? null,
          groupLevel: payload?.groupLevel ?? null,
          actionBy: payload?.actionBy ?? null,
          checkList: payload.checkList ?? null,
          demurrageInstLinerAttDtls: demurrageInstLinerAttDtls ?? null,
          linerId: +state.navbarTop.linerId,
          cfsPartnerId: payload?.cfsPartnerId,
          emptyYardPartnerId: payload?.emptyYardPartnerId,
          nextLevel: payload?.nextLevel >= 0 ? payload?.nextLevel : null,
          pickUpLocationName:payload?.pickUpLocationName || '',
          version:payload?.version,
          ...((payload?.unstuffing != '' && payload?.unstuffing != null && payload?.unstuffing != '0')?{unstuffing: payload?.unstuffing} : {})
        },
      });
      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);
      return {};
    }
  }
);

export const getDefoultPickuLocation = createAsyncThunk(
  'instruction/getDefoultPickuLocation',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `/api/edo-rest-v2/v2/pickup/getPickUpDetails/${payload?.blId}?linerId=${payload?.selectedLinerId}`
      );
      return response.data.pickupLocation;
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);
      return {};
    }
  }
);

export const getInstructionAgentTypes = createAsyncThunk(
  'pymtModedropdown/getInstructionAgentTypes',
  async ({ partnerCountry, linerId, language }: { partnerCountry: string, linerId: number | string, language: string }, { dispatch }: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=${language ?? "EN"}&codeType=AGENT_TYPE&linerId=${linerId}&countryCode=${partnerCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          },
          headers: {
            Authorization:
              'Bearer jmVm90UwpC5gNPBYiEEMlFmwq9HKo524YxxVWz43FrAWvELEUzSxzsUSYGWwCA8WmvYwNoqdKhlFBehn6n7IkPv0pq9Y9wRVx90fTegJtUCcBmGLLhyEyLj6ZlXle1JAlDatIiOUurZI6CquQJTQ5ajuduAQvo0HswRERfsikOZ2skYj6g4RKCUK8dEPQUgr73pDIL3tjfuQkcTSKBcCvT10LQZpCzLodVON3lj6Sa3IYFz2xE1JUhb6nev',
          },
        }
      );
      let index = 0;
      const instructionTypes = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
        index: index++,
      }));

      dispatch(updateInstructionTypes(instructionTypes));
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const getInstructionDelegationTypes = createAsyncThunk(
  'pymtModedropdown/getInstructionDelegationTypes',
  async ({ partnerCountry, linerId, language }: { partnerCountry: string, linerId: number | string, language: string }, { dispatch }: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=${language ?? "EN"}&codeType=DELEGATION_TYPE&linerId=${linerId}&countryCode=${partnerCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          },
          headers: {
            Authorization:
              'Bearer jmVm90UwpC5gNPBYiEEMlFmwq9HKo524YxxVWz43FrAWvELEUzSxzsUSYGWwCA8WmvYwNoqdKhlFBehn6n7IkPv0pq9Y9wRVx90fTegJtUCcBmGLLhyEyLj6ZlXle1JAlDatIiOUurZI6CquQJTQ5ajuduAQvo0HswRERfsikOZ2skYj6g4RKCUK8dEPQUgr73pDIL3tjfuQkcTSKBcCvT10LQZpCzLodVON3lj6Sa3IYFz2xE1JUhb6nev',
          },
        }
      );
      let index = 0;
      const instructionTypes = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
        index: index++,
      }));

      dispatch(updateStandingInstructionTypes(instructionTypes));
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const saveSnooze = createAsyncThunk(
  'snooze/saveSnooze',
  async (payload: any) => {
    try {
      const response = await axiosInstance.post(
        '/api/edo-rest-v1/v1/bl/saveSnoozeDetails',
        {
          blEventId: payload.blEventId,
          snoozeStatus: payload?.snooze ? '2013' : '2014',
          snoozeDays: payload?.noOfDays,
          snoozeRemarks: payload?.userSnoozeRemark,
          //  snoozeDate:payload?.snoozeDate,
          snoozeEmailId: payload?.emailTo,
          snoozeSubject: payload?.subject,
          externalRemarks: payload?.externalRemarks,
          type: "3"
        }
      );
      return response
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const getSnooze = createAsyncThunk(
  'instruction/getSnooze',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `api/edo-rest-v1/v1/bl/getBlDocDetails?blEventId=${payload.blEventId}`
      );

      return {
        next: null,
        previous: null,
        data: {
          blId: response?.data?.blId,
          blEventId: response?.data?.blEventId,
          docType: response?.data?.docType,
          docCategory: response?.data?.docCategory,
          eventId: response?.data?.eventId || null,
          //returnLoc: response?.data?.returnLoc,
          timestamp: response?.data?.timestamp,
          docId: response?.data?.docId,
          docStatus: response?.data?.docStatus,
          createdUser: response?.data?.createdUser,
          docStatusId: response?.data?.docStatusId,
          snoozeEmailId: response?.data?.snoozeEmailId,
          snoozeSubject: response?.data?.snoozeSubject,
          snoozeRemarks: response?.data?.snoozeRemarks,
          snoozeStatus: response?.data?.snoozeStatus,
          snoozeDays: response?.data?.snoozeDays,
          snoozeTimestamp: response?.data?.snoozeTimestamp,
          snoozeEndTimestamp: response?.data?.snoozeEndTimestamp,
          snoozedBy: response?.data?.snoozedBy,
          externalRemarks: response?.data?.externalRemarks
        },
      };
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);

export const saveExtensionRequest = createAsyncThunk(
  'overstay/saveExtensionRequest',
  async (payload: any) => {
    try {
      const response = await axiosInstance.post(
        '/api/edo-rest-v2/v2/extensionRequest/submitExtensionRequest',
        {
          blId: payload.blId,
          extensionRequestId: isNaN(payload.extensionRequestId) ? null : +payload.extensionRequestId,
          requestedPartnerId: payload.requestedPartnerId,
          containerDetails: payload.containerDetails,
          userRemarks: payload.userRemark,
          customerEmailId: payload.customerEmailId,
          emailId: payload.emailId,
          remarks: payload.remarks,
          status: payload.status,
          companyName: payload.companyName,
          address: payload.address,
          taxId: payload.taxId,

          customerCode: payload.customerCode,
          extensionReason: payload.extensionReason,

          country: payload.country,
          linerId: payload.linerId,
          shipmentType: payload.shipmentType,
          instructionType: payload.instructionType,
          currency: payload.currency ?? payload.ccy ?? ''
        }
      );
      return response
    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);

export const getExtensionRequest = createAsyncThunk(
  'instruction/getExtensionRequest',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `api/edo-rest-v2/v2/extensionRequest/getExtensionRequest/${payload?.docId}?linerId=${payload.selectedLinerId}`
      );

      return {

        data: {
          blId: response?.data?.blId,
          requestedPartnerId: response?.data?.requestedPartnerId,
          containerDetails: response?.data?.containerDetails?.map?.((item: any) => ({
            containerPickupId: item.containerPickupId,
            cntNo: item.cntNo,
            pickupLocation: item.pickupLocation,
            pickupDate: item.pickupDate,
            truckerName: "",
            truckerId: "",
            deliveryLocationType: item.deliveryLocationType,
            currency: item.currency,
            containerReturnDate: item.returnDate,
            returnLocation: item.returnLocation,


          })),
          country: response?.data.country,
          taxId: response?.data.taxId,
          companyName: response?.data.companyName,
          address: response?.data.address,
          emailId: response?.data.emailId,

          customerEmailId: response?.data?.customerEmailId,
          extensionRequestId: response?.data?.extensionRequestId,
          status: response?.data?.status,
          remarks: response?.data?.remarks,
          userRemarks: response?.data?.userRemarks,
          customerCode: response?.data?.customerCode,
          blNo: response?.data?.blNo,
          shipmentType: response?.data?.shipmentType,
          instructionType: response?.data?.instructionType
        },
      };
    } catch (e) {

      const error = e as AxiosError;

      console.error('Overstay', error);
      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);

export const populateExtensionRequest = createAsyncThunk(
  'instruction/populateExtensionRequest',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `api/edo-rest-v2/v2/extensionRequest/getExtensionRequest/${payload?.docId}?linerId=${payload.selectedLinerId}`
      );

      return {

        data: {
          blId: response?.data?.blId,
          requestedPartnerId: response?.data?.requestedPartnerId,
          containerDetails: response?.data?.containerDetails?.map?.((item: any) => ({
            containerPickupId: item.containerPickupId,
            cntNo: item.cntNo,
            pickupLocation: item.pickupLocation,
            pickupDate: item.pickupDate,
              containerReturnDate: item.returnDate,
            returnLocation: item.returnLocation,
            
            truckerName: "",
            truckerId: "",
            currency: item.currency ?? "",
            deliveryLocationType: item.deliveryLocationType ?? 0
          })),
          customerEmailId: response?.data?.customerEmailId,
          extensionRequestId: response?.data?.extensionRequestId,
          status: response?.data?.status,
          remarks: response?.data?.remarks,
          userRemarks: response?.data?.userRemarks,
          customerCode: response?.data?.customerCode,
          emailId: response?.data?.emailId,
          taxId: response?.data?.taxId,
          address: response?.data?.address,
          companyName: response?.data?.companyName,
          shipmentType: response?.data?.shipmentType,
          instructionType: response?.data?.instructionType,


        },
      };
    } catch (e) {

      const error = e as AxiosError;

      console.error('Overstay', error);
      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);

export const deleveryLocTypeList = createAsyncThunk(
  'overstay/deleveryLocTypeList',
  async ({ dataCountry, linerId }: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=DELIVERY_LOC_TYPE&linerId=${linerId}&countryCode=${dataCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          }
        }
      );

      const deleveryLocTypeOption = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
      }));
      console.log(deleveryLocTypeOption,'<<<<deleveryLocTypeOption')
      return deleveryLocTypeOption



    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);




export const returnLocTypeList = createAsyncThunk(
  'overstay/returnTypeList',
  async ({ dataCountry, linerId }: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=RETURN_LOC_TYPE&linerId=${linerId}&countryCode=${dataCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          }
        }
      );

      const returnLocTypeOption = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
      }));
      return returnLocTypeOption



    } catch (e) {
      const error = e as AxiosError;
      return error;
    }
  }
);


/* export const getCheckList = createAsyncThunk(
  'instruction/getCheckList',
  async (payload: any) => {
    try {
      const response = await axiosInstance.post(
        
        `/api/edo-rest-v1/v1/common/attachmentConfig?countryCode=KE&instructionTy=8041&linerId=24118`
      );
 

      return response.data.map((item:any)=>({
   
        docId: item.docId,
        name:item.docName,
        check:null,
        linerId: "",
        checkListUpdated: "",
        remarks: "",
        isMandatory:item.isMandatory=='Y',
        groupLevel:item.companyType
      }))
    
      
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
); */

export const mnBankNameList = createAsyncThunk(
  'payment/mnBankNameList',
  async ({ dataCountry, linerId }: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=MN_BANK_NAME&linerId=${linerId}&countryCode=${dataCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          }
        }
      );

      const mnBankNmOption = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
      }));
      return mnBankNmOption

    } catch (e) {
      const error = e as AxiosError;
      return [];
    }
  }
);

export const fetchCFSNameByCountry = createAsyncThunk(
  "CRR/getCFSDDList",
  async ({ country, port, byLocation = false }: any, { getState }: any) => {
    try {
      const location = getState().userProfile.selectedPort;

      const endpoint = port && byLocation ? "getPartnerDDListByLocation" : "getPartnerDDList";
      const params = new URLSearchParams({
        countryCode: country,
        port: port,
        type: country === 'MZ' ? "cfs,terminal,icd,yard" : "cfs,icd,yard",
        ...((location) && { location })
      });

      const response = await axiosInstance.post(`/api/user-management/v1/customer/${endpoint}?${params}`);
      const options =
        response?.data?.map((item: any) => ({
          value: item?.mstPartnerId,
          text: item?.partnerNm,
        })) || [];
      // dispatch(updateLinerOptions(options));
      return options;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
);


export const fetchPickupCFSICDName = createAsyncThunk(
  "pickUpInstruction/fetchPickupCFSICDName",
  async (payload:any) => {
    try {
      const response = await axiosInstance.post(`/api/user-management/v1/customer/getPartnerDDListByLocation?countryCode=${payload?.countryCode}&type=${payload?.type}`);
      const options =
        response?.data?.map((item: any) => ({
          value: item?.mstPartnerId,
          text: item?.partnerNm,
        })) || [];
      return [{value: 0, text:""}, ...options];
    } catch (error) {
      console.error(error);
      return {};
    }
  }
);

export const fetchEmptyYardNameByCountry = createAsyncThunk(
  "CRR/getEmptyYardDDList",
  async ({ country, port, byLocation, showAll = false }: any, { getState }: any) => {
    try {
      const location = getState().userProfile.selectedPort;
      const endpoint = port && byLocation ? "getPartnerDDListByLocation" : "getPartnerDDList";
      const params = new URLSearchParams({
        countryCode: country,
        port: port,
        type: country === 'MZ' ? "cfs,empty_yard,terminal,yard" : "empty_yard,yard",
        ...((location) && { location })
      });

      const response = await axiosInstance.post(`/api/user-management/v1/customer/${endpoint}?${params}`);

      const options =
        response?.data?.map((item: any) => ({
          value: item?.mstPartnerId,
          text: item?.partnerNm,
        })) || [];
      // dispatch(updateLinerOptions(options));
      return options;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
);

export const getLanguageList = createAsyncThunk(
  'payment/getLanguageList',
  async ({ dataCountry, linerId }: any) => {
    try {
      const response = await axiosCacheInstance.get(
        `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=&codeType=LANGUAGE_TYPE&linerId=${linerId}&countryCode=${dataCountry}`,
        {
          cache: {
            ttl: 10 * 60 * 1000
          }
        }
      );

      const getLanguageList = response.data.map((item: any) => ({
        value: item.codeId,
        text: item.codeDesc,
        lang: item.codeLang,
      }));
      return getLanguageList

    } catch (e) {
      const error = e as AxiosError;
      return [];
    }
  }
);
export const addTruckerDetails = createAsyncThunk(
  'instruction/addTruckerDetails',
  async (payload: any, { dispatch }) => {
    try {
      const response = await axiosInstance({
        url: `/api/edo-rest-v2/v2/trucker/addTruckerDetails`,
        method: 'POST',
        data: payload
      });

      toast.success(response?.data?.responseMsg ?? 'Created successfully!');

      //if (payload?.docId) payload?.dispatch?.(getDemurrageView(payload.docId));



      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      toast.error(error?.message ?? "Network Error")
      return {};
    }
  }
);
export const updateTruckerDetails = createAsyncThunk(
  'instruction/updateTruckerDetails',
  async (payload: any, { dispatch }) => {
    try {
      const response = await axiosInstance({
        url: `/api/edo-rest-v2/v2/trucker/updateTruckerById`,
        method: 'PUT',
        data: payload
      });

      toast.success(response?.data?.responseMsg ?? 'Created successfully!');

      //if (payload?.docId) payload?.dispatch?.(getDemurrageView(payload.docId));



      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      toast.error(error?.message ?? "Network Error")
      return {};
    }
  }
);

export const getTruckerDetails = createAsyncThunk(
  'instruction/getTruckerDetails',
  async (id: any, { dispatch }) => {
    try {
      const response = await axiosInstance({
        url: `/api/edo-rest-v2/v2/trucker/getTruckerDetailsById?masterTruckerId=${id}`,
        method: 'GET'

      });



      //if (payload?.docId) payload?.dispatch?.(getDemurrageView(payload.docId));



      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      toast.error(error?.message ?? "Network Error")
      return {};
    }
  }
);
export const bulkPaymentProcessConfig = createAsyncThunk(
  'instruction/bulkPaymentProcessConfig',
  async (payload: any, { dispatch }) => {
    try {
      const response = await axiosInstance({
        url: `/api/edo-rest-v2/v2/bulkConfig/bulkPaymentProcessConfig`,
        method: 'POST',
        data: payload
      });

      // toast.success(response?.data?.responseMsg??'Created successfully!');

      //if (payload?.docId) payload?.dispatch?.(getDemurrageView(payload.docId));



      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      toast.error(error?.message ?? "Network Error")
      return {};
    }
  }
);


export const getBulkPaymentProcessConfig = createAsyncThunk(
  'instruction/getBulkPaymentProcessConfig',
  async (id: any, { dispatch }) => {
    try {
      const response = await axiosInstance({
        url: `/api/edo-rest-v2/v2/bulkConfig/getBulkPaymentProcessConfigById?bulkPaymentProcessConfigId=${id}`,
        method: 'GET'

      });

      //   toast.success(response?.data?.responseMsg??'Created successfully!');

      //if (payload?.docId) payload?.dispatch?.(getDemurrageView(payload.docId));



      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      toast.error(error?.message ?? "Network Error")
      return {};
    }
  }
);


export const getSarsCustomHistory = createAsyncThunk(
  "blDashboard/getSarsCustomHistory",
  async (payload: {
    blIdDecrypted: string;
    linerId: string | number | undefined;
  }) => {
    try {
      const { blIdDecrypted, linerId } = payload;

      if (!blIdDecrypted || linerId == null || linerId == "") {
        return [];
      }

      const response = await axiosInstance.get(
        `/api/edo-rest-v1/v1/coreor/bl/${blIdDecrypted}?linerId=${linerId}`
      );
      const containerList = response.data?.containerList ?? [];
      return containerList.map((v: any) => ({
        container_number: v?.containerNo ?? "",
        customs_release_date:
          v?.customsReleaseDate ??  null,
        customs_release_status:
          v?.customsReleaseStatus  ?? "",
        remarks: v?.customsReleaseRemarks ?? "",
        created_date: v?.createdDate ?? "",
        modified_date: v?.modifiedDate ?? "",
      }));
    } catch (e) {
      console.error("Custom Release Field Changes Error", e);
      return [];
    }
  }
);

